import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Field } from "@/modules/FormTemplate/models/Field";
import {
  FIELD_WIDTHS,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  VJSF_OPTIONS,
  ICON_LIST_FIXED
} from "@/shared/constants/FormConstants";
import {
  DATA_TYPE,
  DATA_TYPE_SIMPLE,
  DATE_ID,
  FIELD_TYPE,
  FORMULA_TYPE,
  FORM_TEMP_CONSTANTS,
  FORM_TEMP_VALIDATORS,
  MISSING_LIST_ERROR,
  VISUAL_ELEMENT_TYPE
} from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { ListSchema } from "@/modules/List/models/ListSchema";
import { Schema } from "@/modules/FormTemplate/models/Schema";
import { ListService } from "@/modules/List/services/ListService";
import { Http } from "@status/codes";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { Option } from "@/modules/List/models/Option";
import { nanoid } from "nanoid";
import { FormulaChips } from "@/modules/FormTemplate/models/FormulaChips";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Condition } from "@/modules/FormTemplate/models/Condition";
import { EditField } from "@/modules/FormTemplate/models/EditField";
import _ from "lodash";
import { TYPE_BASE } from "@/modules/InfoGroup/constants/InfoGroupConstants";
import { ManagedListsService } from "@/shared/services/ManagedListsService";
import {
  BASICO,
  COMPONENT_TAGS,
  STATE,
  MANAGED_LISTS_TYPES,
  REGEX_NUMBER,
  SPECIAL_CHARS_REGEX
} from "@/shared/constants/GeneralConstants";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { ListQuery } from "@/modules/List/models/ListQuery";
import {
  ERROR_NAME_DUPLICATE,
  NAME_KEY_CHART
} from "@/shared/components/AddFieldGroup/constants/FieldGroupConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { PreventKey } from "@/shared/mixins/mixins";
import { AxiosError } from "axios";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { mapGetters } from "vuex";
import { Icon } from "@/shared/models/Icon";
import CalculatorComponent from "@/modules/GeneralRules/components/FormActionModal/components/CalculatorComponent/CalculatorComponent.vue";

Vue.use(Vuetify);
@Component({
  name: "AddFields",
  components: {
    DynamicSelect,
    ModifVJsfInput,
    CalculatorComponent
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class AddFields extends PreventKey {
  @Inject() listService!: ListService;
  @Inject() managedListsService!: ManagedListsService;

  @Prop({ default: false }) private isEditingGroupField!: boolean;
  @Prop() private fields!: Field[];
  @Prop() private dialog!: boolean;
  @Prop() private formConditions!: Condition[];
  @Prop() private iconsList!: DynamicSelectConfig;
  @Prop() private dataProp?: EditField;
  @Prop() private indexConditionalProp?: number;
  @Prop() refreshLists!: number;

  dataToMainView!: MenuDataStructure;
  iconsListDefault = ICON_LIST_FIXED;
  fieldForm = false;
  enumValues: Array<string> = [];
  listValues: Array<ListSchema> = [];
  dataTypeList = [{ label: "", value: "" }];
  dataSchemaTypeModel = [{ name: "", id: "" }];
  fieldTypeListModel = [{ id: "", name: "" }];
  listIconModel = [{ value: "", name: "" }];
  visualElementModel = [{ id: "", name: "" }];
  fieldWidthModel = [{ id: "", name: "" }];
  visualElementList = [{ label: "", value: "" }];
  selectedConditionModel = [{ id: "", name: "" }];
  enumValue = "";
  tooltip = false;
  listKey = 0;

  fieldTypeList = FIELD_TYPE;
  blankSpacesLengthRequieredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR,
    FORM_TEMP_VALIDATORS.MAX_LENGTH
  ];
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  maxLength = [FORM_TEMP_VALIDATORS.MAX_LENGTH];
  minValue = [FORM_VALIDATORS.MIN_VALUE];
  minStepValue = [FORM_VALIDATORS.MIN_STEP_VALUE];
  maxValue = [FORM_VALIDATORS.MAX_VALUE];
  minLessThanMax = [FORM_VALIDATORS.MIN_LESS_THAN_MAX];
  integerDecimalField = [FORM_VALIDATORS.INTEGER_AND_DECIMAL_NUMBER_FIELD];
  sliderMaxValueMinimum = 1;
  CONDITION_MINIMUM_MIN_VALUE =
    FORM_TEMP_CONSTANTS.CONDITION_SLIDER_FIELD.MINIMUM_MIN_VALUE;
  CONDITION_MINIMUM_MAX_VALUE =
    FORM_TEMP_CONSTANTS.CONDITION_SLIDER_FIELD.MINIMUM_MAX_VALUE;
  VJSF_OPTIONS = VJSF_OPTIONS;
  FORM_TEMP_CONSTANTS = FORM_TEMP_CONSTANTS;

  urlPattern = [FORM_VALIDATORS.URL_PATTERN];
  listDisabledField = false;
  formulaDisableField = false;
  order = 0;
  formulaText = "";
  formulaField = "";
  conditional = false;
  listName = "";
  conditionIndex = -1;
  preCondition = -1;
  indexEditing = -1;
  isEditing = false;
  isEditingCondition = false;
  selectedCondition: Condition = {
    condition: {
      conditionName: "",
      isNumeric: false,
      isArray: false,
      parentField: ""
    },
    fields: []
  };
  listId = "";
  formulaChips: FormulaChips[] = [];
  showMoreInfo = false;
  model = {};
  schema = {
    type: "object",
    properties: {
      field: {}
    },
    "x-cols": {
      md: 12
    }
  };
  field: Field = {
    indicator: true,
    order: 0,
    type: "",
    list: "",
    key: "",
    conversationTitle: "",
    required: true,
    visible: true,
    editable: true,
    visualElement: "",
    width: 12,
    uiSetup: {
      iconUrl: "",
      helpText: ""
    },
    schema: {
      title: "",
      type: ""
    },
    summaryText: "",
    summary: false
  };

  fieldModalTitle = FORM_TEMP_CONSTANTS.ADD_FIELD_TITLE;
  URL_ICON = FORM_TEMP_CONSTANTS.LABEL.URL_ICON;
  HELP_TEXT = FORM_TEMP_CONSTANTS.LABEL.HELP_TEXT;
  TITLE = FORM_TEMP_CONSTANTS.LABEL.TITLE;
  CONV_TITLE = FORM_TEMP_CONSTANTS.LABEL.CONVERSATION_TITLE;
  VISUAL_ELEM = FORM_TEMP_CONSTANTS.LABEL.VISUAL_ELEM;
  MIN_VALUE = FORM_TEMP_CONSTANTS.LABEL.MIN_VALUE;
  MAX_VALUE = FORM_TEMP_CONSTANTS.LABEL.MAX_VALUE;
  STEP = FORM_TEMP_CONSTANTS.LABEL.STEP;
  ADD_VALUES = FORM_TEMP_CONSTANTS.LABEL.ADD_VALUES;
  SEARCH_LIST = FORM_TEMP_CONSTANTS.LABEL.SEARCH_LIST;
  ADD_LIST = FORM_TEMP_CONSTANTS.LABEL.ADD_LIST;
  FIELD_TYPE = FORM_TEMP_CONSTANTS.LABEL.FIELD_TYPE;
  DATA_TYPE = FORM_TEMP_CONSTANTS.LABEL.DATA_TYPE;
  VISIBLE = FORM_TEMP_CONSTANTS.LABEL.VISIBLE;
  EDITABLE = FORM_TEMP_CONSTANTS.LABEL.EDITABLE;
  REQUIRED = FORM_TEMP_CONSTANTS.LABEL.REQUIRED;
  INDICATOR = FORM_TEMP_CONSTANTS.LABEL.INDICATOR;
  CONDITIONAL = FORM_TEMP_CONSTANTS.LABEL.CONDITIONAL;
  CONDITION = FORM_TEMP_CONSTANTS.LABEL.CONDITION;
  HINT = FORM_TEMP_CONSTANTS.LABEL.HINT;
  HINT_LIST = FORM_TEMP_CONSTANTS.LABEL.HINT_LIST;
  HINT_SEARCH_LIST = FORM_TEMP_CONSTANTS.LABEL.HINT_SEARCH_LIST;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  FORMULA_TEXT = FORM_TEMP_CONSTANTS.FORMULA_TEXT;
  FORMULA_HELPER = FORMULA_TYPE.HELPER;
  FIELD_WIDTH = FORM_CONSTANTS.LABEL.FIELD_WIDTH;
  SUMMARY_TEXT = FORM_TEMP_CONSTANTS.SUMMARY_LABEL.TEXT;
  SUMMARY_DATA = FORM_TEMP_CONSTANTS.SUMMARY_LABEL.DATA;
  FIELD_WIDTHS = FIELD_WIDTHS;
  FIELD_INFO = FORM_TEMP_CONSTANTS.LABEL.INFO_FIELD;
  MORE_INFO = FORM_CONSTANTS.BUTTON.MORE_INFO;
  FIELD_CONFIG = FORM_TEMP_CONSTANTS.LABEL.FIELD_CONFIG;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;

  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  textAreaClass = STYLE_CLASSES.TEXT_AREA;
  switchClass = STYLE_CLASSES.SWITCH;
  ELEMENT_INACTIVE = STYLE_CLASSES.ELEMENT_INACTIVE;
  visualElementCounter = 1;
  showCondition = false;
  formKey = 1;

  dynamicSelectList: DynamicSelectData[] = [];
  dynamicSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.SEARCH_LIST,
    hint: this.HINT_SEARCH_LIST,
    required: true
  };
  iconSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    chips: false,
    filled: false,
    messageLabel: this.URL_ICON,
    onlyIcon: true
  };

  fieldTypeListConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.fieldTypeList.map(item => {
      return { name: item.label, id: item.value };
    }),
    chips: false,
    filled: false,
    messageLabel: this.FIELD_TYPE,
    required: true
  };
  fieldSchemaTypeConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    chips: false,
    filled: false,
    messageLabel: this.DATA_TYPE,
    required: true
  };

  visualSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    chips: false,
    filled: false,
    messageLabel: this.VISUAL_ELEM,
    required: true
  };

  fieldWidthConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: FIELD_WIDTHS.map(item => {
      return { name: item.name, id: item.value };
    }),
    chips: false,
    filled: false,
    messageLabel: this.FIELD_WIDTH
  };
  formConditionConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.formConditions.map((item, index) => {
      return {
        name: item.condition.conditionName,
        id: `${index}`,
        isNumeric: item.condition.isNumeric,
        isArray: item.condition.isArray,
        condition: item.condition,
        fields: item.fields
      };
    }),
    chips: false,
    filled: false,
    messageLabel: this.CONDITION
  };

  stateList = true;
  editComparationStr = "";
  invalidEdit = false;

  loadingPropData = false;
  async mounted() {
    this.clearField();
    await this.loadListByName();
    await this.organizeFormToShow();
  }

  updateCalculator(value: string) {
    this.invalidEdit = this.formulaText == value;
    this.formulaText = value;
    this.formulaValidator();
  }

  set selectIcon(value: string) {
    const option = this.iconSelectConfig.listAll.find(
      (item: any) => item.value == value
    );
    if (option != undefined) {
      this.listIconModel = [
        {
          value: option?.value ?? "",
          name: option?.name ?? ""
        }
      ];
    }
  }

  get selectIcon() {
    return this.listIconModel[0].value;
  }

  set selectFieldType(value: string) {
    const option = this.fieldTypeListConfig.listAll.find(
      item => item.id === value
    );
    this.fieldTypeListModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectFieldType() {
    return this.fieldTypeListModel[0].id;
  }

  set selectDataSchema(value: string) {
    const option = this.fieldSchemaTypeConfig.listAll.find(
      item => item.id === value
    );
    this.dataSchemaTypeModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectDataSchema() {
    return this.dataSchemaTypeModel[0].id;
  }

  set selectVisualElement(value: string) {
    const option = this.visualSelectConfig.listAll.find(
      item => item.id === value
    );
    this.visualElementModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectVisualElement() {
    return this.visualElementModel[0].id;
  }
  set selectWidth(value: string) {
    const option = this.fieldWidthConfig.listAll.find(
      item => item.id === value
    );
    this.fieldWidthModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectWidth() {
    return this.fieldWidthModel[0].id;
  }

  set selectFormCondition(value: any) {
    const option = this.formConditionConfig.listAll.find(
      item => item.id === value
    );
    this.selectedConditionModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectFormCondition() {
    return this.selectedConditionModel;
  }

  @Watch("selectedConditionModel")
  changeFormCondition() {
    this.selectedCondition = this.selectFormCondition;
  }

  @Watch("listIconModel")
  changeIcon() {
    this.field.uiSetup!.iconUrl = this.listIconModel[0].value;
  }

  @Watch("visualElementModel")
  changeDataType() {
    this.field.visualElement = this.selectVisualElement;

    if (
      this.field.visualElement &&
      this.field.visualElement !== FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING
    ) {
      this.field.schema.type =
        DATA_TYPE_SIMPLE[
          this.field.visualElement as keyof typeof DATA_TYPE_SIMPLE
        ];
    }
    this.dynamicSelectList = [];
    this.enumValues = [];
  }
  @Watch("fieldTypeListModel")
  changeType() {
    this.field.model = {};
    this.field.list = "";
    this.enumValues = [];
    this.field.type = this.fieldTypeListModel[0].id;
  }

  @Watch("dataSchemaTypeModel")
  changeSchemaType() {
    if (DATA_TYPE.string.find(item => item.value == this.selectDataSchema)) {
      this.field.schema.type = this.selectDataSchema;
    }
  }

  @Watch("fieldWidthModel")
  changeWidth() {
    this.field.width = parseInt(this.selectWidth);
  }

  @Watch("dialog")
  asociateConditionalField() {
    if (
      this.indexConditionalProp !== undefined &&
      this.indexConditionalProp >= 0 &&
      this.dialog
    ) {
      this.addFieldConditional(true, this.indexConditionalProp);
    }
  }

  @Watch("fieldForm")
  validateLengthOnRadioAndCheck() {
    if (
      COMPONENT_TAGS.includes(this.field.visualElement) &&
      this.field.type === BASICO
    ) {
      this.validateRadioAndCheckListValues();
    }
  }

  @Watch("enumValues")
  validateRadioAndCheckListValues() {
    if (
      this.dataProp &&
      this.dataProp.fieldIndex != undefined &&
      this.loadingPropData
    ) {
      return;
    }
    const validation =
      this.field.schema.title.length > 0 &&
      this.enumValues &&
      this.enumValues.length > 0 &&
      this.field.visualElement.length > 0;
    this.fieldForm = validation;
  }
  async getIconsImages() {
    try {
      const iconResponse = await this.managedListsService.getIconsImages(
        MANAGED_LISTS_TYPES.ICONS
      );

      this.iconsListDefault = (iconResponse.data as Icon[]) || ICON_LIST_FIXED;
      this.iconSelectConfig.listAll = this.iconsListDefault.map(icon => {
        return { id: icon.value, value: icon.value, name: icon.name };
      });
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  addFieldConditional(val: boolean, index: number) {
    this.conditional = val;
    this.conditionIndex = index;
    this.selectedCondition = this.formConditions[index];
    this.showCondition = false;
  }
  async changeFieldType(isEditing?: boolean, fieldType?: string) {
    this.field.type = fieldType ?? this.fieldTypeListModel[0].id;
    this.visualElementList =
      VISUAL_ELEMENT_TYPE[this.field.type as keyof typeof VISUAL_ELEMENT_TYPE];

    if (this.visualElementList !== undefined) {
      this.visualSelectConfig.listAll = this.visualElementList.map(item => {
        return { id: item.value, name: item.label };
      });
    }
    this.listDisabledField =
      this.field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST;
    this.formulaDisableField =
      this.field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA;

    if (isEditing) {
      this.dynamicSelectList = [];
      this.field.visualElement = "";
      this.visualElementCounter++;
      this.cleanOptions();
    }
    if (this.formulaDisableField) {
      this.formulaChips = [];
      for (const field of this.fields) {
        if (
          !(
            field.schema.type == FORM_TEMP_CONSTANTS.FIELD_TYPE.NUMBER ||
            (field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST &&
              field.visualElement !== FORM_TEMP_CONSTANTS.FIELD_TYPE.CHECKBOX)
          )
        ) {
          continue;
        }
        if (
          field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST &&
          field.list != ""
        ) {
          const listData = await this.listService.getListById(field.list);
          const optionsList = listData.data?.options || [];
          const found: Option[] = optionsList.filter(
            e => e.score == undefined && !REGEX_NUMBER.test(e.value)
          );
          if (found.length > 0) {
            continue;
          }
        }
        this.formulaChips.push({
          title: field.schema.title,
          name: field.schema.title,
          key: field.key
        });
      }
    }
    if (
      this.listDisabledField &&
      this.dynamicSelectConfig.listAll.length == 0
    ) {
      await this.loadListByName();
    }
  }

  async changeElement(isEditing?: boolean, element?: string) {
    this.field.visualElement = element ?? this.selectVisualElement;

    const searchTypeList =
      DATA_TYPE[this.field.visualElement as keyof typeof DATA_TYPE];
    if (searchTypeList != undefined) {
      this.fieldSchemaTypeConfig.listAll = searchTypeList.map(item => {
        return { id: item.value, name: item.label };
      });
    }

    if (isEditing) {
      this.dynamicSelectList = [];
      this.field.schema.type = "";
      this.listKey++;
      this.cleanOptions();
    }
  }

  saveListValue() {
    if (this.enumValue.trim()) {
      if (this.enumValues.includes(this.enumValue)) {
        Snackbar.popWarning(FORM_TEMP_CONSTANTS.MESSAGE.EXISTING_ITEM);
        return;
      }
      this.enumValues.push(this.enumValue);
      this.enumValue = "";

      this.field.schema = {
        ...this.field.schema,
        enum: this.enumValues,
        items: {
          enum: this.enumValues,
          type: FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING
        }
      };
    }
  }

  deleteListValue(index: number) {
    this.enumValues.splice(index, 1);
  }

  addField() {
    const fieldKnow = this.fields.find(field => {
      return (
        field.schema.title.trim() == this.field.schema.title.trim() &&
        field.key != this.field.key
      );
    });
    if (fieldKnow) {
      Snackbar.popError(ERROR_NAME_DUPLICATE);
      return;
    }

    this.fillField();
    const data: EditField = { formField: this.field };
    if (
      data.formField.type == FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST &&
      (data.formField.list == "" || !data.formField.list)
    ) {
      return;
    }

    if (this.field.schema.readOnly) {
      this.field.schema["x-style"] = STYLE_CLASSES.FORMULA;
    } else {
      delete this.field.schema["x-style"];
    }

    if (this.isEditing) {
      this.isEditing = false;
      data.fieldIndex = this.indexEditing;
      this.field.order = this.order;

      if (this.isEditingCondition) {
        this.isEditingCondition = false;
        this.field.key = this.formConditions[this.preCondition].fields[
          this.indexEditing
        ].key;
        data.conditionIndex = this.conditionIndex;
        data.preCondition = this.preCondition;

        this.$emit(
          FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.ADD_EDITED_CONDITION,
          data
        );
      } else if (this.conditional) {
        this.fields.splice(this.indexEditing, 1);

        data.conditionIndex = this.conditionIndex;
        this.field.order =
          this.formConditions[this.conditionIndex].fields.length + 1;

        this.$emit(
          FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.ADD_NEW_CONDITION,
          data
        );
      } else {
        this.field.key = this.fields[this.indexEditing].key;
        data.formField.conversationTitle = data.formField.schema.title;

        this.$emit(FORM_TEMP_CONSTANTS.EVENTS.FIELD.ADD_EDITED, data);
      }
    } else {
      if (this.conditional) {
        data.conditionIndex = this.conditionIndex;
        this.field.order =
          this.formConditions[this.conditionIndex].fields.length + 1;

        this.$emit(
          FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.ADD_NEW_CONDITION,
          data
        );
      } else {
        this.$emit(FORM_TEMP_CONSTANTS.EVENTS.FIELD.ADD_NEW, data);
      }
    }

    this.clearField();
  }

  fillField() {
    this.field.schema = this.schema.properties.field as Schema;
    this.field.conversationTitle =
      this.field.conversationTitle || this.field.schema.title;
    this.field.order = this.fields.length + 1;
    this.field.key = `f${nanoid(8)}t`;

    if (this.field.type == FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA) {
      this.field.formula = this.formulaField;
    }

    if (this.field.type == FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST) {
      this.field.list = this.dynamicSelectList[0]?.id ?? this.listId;
      if (this.field.list == "" || !this.field.list) {
        Snackbar.popError(MISSING_LIST_ERROR);
      }
    }
  }

  @Watch("field", { deep: true })
  showFieldPreview() {
    if (this.isEditing) {
      this.invalidEdit = JSON.stringify(this.field) === this.editComparationStr;
    }

    if (!isNaN(Number(this.field.schema.minimum))) {
      this.maxValue = [
        (v: number): boolean | string => {
          return (
            (v && v > Number(this.field.schema.minimum)) ||
            `${FORM_TEMP_CONSTANTS.MESSAGE.MAX_VAL_FIELD} ${Number(
              this.field.schema.minimum
            )}`
          );
        }
      ];
      this.sliderMaxValueMinimum = Number(this.field.schema.minimum) + 1;
    } else {
      this.sliderMaxValueMinimum = 1;
    }
    if (!isNaN(Number(this.field.schema.maximum))) {
      this.minValue = [
        (v: number): boolean | string => {
          if (
            this.field.schema.maximum &&
            v >= Number(this.field.schema.maximum)
          ) {
            this.field.schema.maximum = Number(this.field.schema.minimum) + 1;
            this.inputSchemaMaximun();
          } else {
            if (
              this.field.schema.maximum &&
              !isNaN(Number(this.field.schema.minimum))
            ) {
              this.field.schema.maximum = Number(this.field.schema.maximum);
            }
          }
          return (
            (v &&
              (v < Number(this.field.schema.maximum) ||
                isNaN(Number(this.field.schema.maximum)))) ||
            `${FORM_TEMP_CONSTANTS.MESSAGE.MIN_VAL_FIELD} ${Number(
              this.field.schema.maximum
            )}`
          );
        }
      ];
    }

    this.schema.properties.field = this.setSchemaFields();
    this.schema["x-cols"] = { md: this.field.width };
  }

  setSchemaFields(): Schema {
    const schema: Schema = {
      title: this.field.schema.title
        ? this.field.schema.title.trim()
        : this.field.schema.title,
      type:
        this.field.schema.type === "date" ? "string" : this.field.schema.type,
      "x-display": this.field.visualElement,
      format: this.field.schema.type === "date" ? this.field.schema.type : "",
      description: this.field.uiSetup?.helpText,
      "x-props": {
        prependIcon: this.field.uiSetup?.iconUrl
      },
      readOnly: !this.field.editable
    };
    if (!this.field.editable) {
      this.field.required = false;
    }
    if (!this.field.visible) {
      this.field.editable = false;
    }
    if (this.field.visualElement !== "select") {
      schema["x-display"] = this.field.visualElement;
    } else {
      schema["x-display"] = "autocomplete";
    }

    if (
      this.field.type == TYPE_BASE.FIELD_TYPE.BASICO.value &&
      this.field.schema.type == TYPE_BASE.INTEGER.DATA.value
    ) {
      schema["maximum"] = TYPE_BASE.INTEGER.DEFAULT.MAXIMUM;
    } else {
      delete schema["maximum"];
    }
    if (this.field.type == FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA) {
      schema.readOnly = true;
      schema.type = "string";
      schema["x-display"] = "string";
    }

    switch (this.field.visualElement) {
      case "slider":
        schema.minimum = this.field.schema.minimum;
        schema.maximum = this.field.schema.maximum;
        Object.assign(schema["x-props"], { "thumb-label": true });
        schema["x-step"] = this.field.schema["x-step"] || 1;
        break;
      case "radio":
        if (this.field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST) {
          schema.oneOf = this.field.schema.oneOf || [];
        } else {
          schema.enum = this.field.schema.enum || [];
        }
        break;
      case "checkbox":
        schema.items = this.field.schema.items || { enum: [], type: "string" };
        break;
      case "select":
        if (this.field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST) {
          schema.oneOf = this.field.schema.oneOf;
          schema["x-itemIcon"] = "icon";
        } else {
          schema.enum = this.field.schema.enum;
        }

        Object.assign(schema["x-props"], {
          outlined: true,
          rounded: true,
          dense: true
        });
        break;
      case "string":
        Object.assign(schema["x-props"], {
          outlined: true,
          rounded: true,
          dense: true
        });
        break;
      case "textarea":
        Object.assign(schema["x-props"], {
          outlined: true,
          rounded: true,
          dense: true,
          "auto-grow": true,
          rows: "1"
        });
    }
    return schema;
  }

  clearField() {
    this.field = {
      indicator: true,
      order: 0,
      type: "",
      list: "",
      key: "",
      conversationTitle: "",
      required: true,
      visible: true,
      editable: true,
      visualElement: "",
      uiSetup: {
        iconUrl: "",
        helpText: ""
      },
      schema: {
        title: "",
        type: "",
        "x-style": ""
      },
      summaryText: "",
      summary: false,
      width: 12
    };
    this.dataTypeList = [{ label: "", value: "" }];
    this.dataSchemaTypeModel = [{ name: "", id: "" }];
    this.fieldTypeListModel = [{ id: "", name: "" }];
    this.listIconModel = [{ value: "", name: "" }];
    this.visualElementModel = [{ id: "", name: "" }];
    this.fieldWidthModel = [{ id: "", name: "" }];
    this.visualElementList = [{ label: "", value: "" }];
    this.enumValues = [];
    this.visualElementList = [];
    this.formulaText = "";
    this.conditionIndex = -1;
    this.indexEditing = -1;
    this.selectedCondition = {
      condition: {
        conditionName: "",
        isNumeric: false,
        isArray: false,
        parentField: ""
      },
      fields: []
    };
    this.conditional = false;
    this.formulaChips = [];
    this.isEditing = false;
    this.isEditingCondition = false;
    this.formulaDisableField = false;
    this.fieldModalTitle = FORM_TEMP_CONSTANTS.ADD_FIELD_TITLE;
    this.showMoreInfo = false;
    this.model = {};
    this.formKey = 1 - this.formKey;
    this.listName = "";
  }

  @Watch("refreshLists")
  async loadListByName() {
    try {
      const filterQuery: ListQuery = { activeList: [STATE.ACTIVE] };

      const response = await this.listService.getChart(filterQuery);

      if (response.code === Http.Found && response.data !== undefined) {
        this.dynamicSelectConfig.listAll = (response.data[
          NAME_KEY_CHART.LIST_ARRAY
        ] as unknown) as DynamicSelectData[];
      } else {
        this.dynamicSelectConfig.listAll = [];
        Snackbar.popWarning(LIST_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async updateSelectList() {
    await this.getData(this.dynamicSelectList[0].id);
  }
  async getData(idReference: string) {
    if (!idReference) return;
    const listValues: Array<ListSchema> = [];
    const enumValues: Array<string> = [];
    this.stateList = true;
    try {
      const responseData = await this.listService.getListById(idReference);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.stateList = responseData.data.state;
        this.dynamicSelectList = [
          {
            id: idReference,
            name: responseData.data.name,
            state: responseData.data.state
          }
        ];

        this.dynamicSelectConfig.listAll.push({
          id: idReference,
          name: responseData.data.name,
          state: responseData.data.state
        });

        responseData.data.options.forEach((option: Option) => {
          if (option.enabled) {
            const listHeader: ListSchema = {
              title: option.title,
              const: option.value,
              score: option.score
            };

            if (option.uiSetup.iconUrl !== "") {
              listHeader.icon = option.uiSetup.iconUrl;
            }

            listValues.push(listHeader);
            enumValues.push(option.title);
          }
        });

        if (
          this.field.visualElement === FORM_TEMP_CONSTANTS.FIELD_TYPE.CHECKBOX
        ) {
          this.field.schema = {
            ...this.field.schema,
            items: {
              oneOf: listValues,
              type: FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING
            }
          };
        } else {
          this.field.schema = {
            ...this.field.schema,
            oneOf: listValues
          };
        }

        this.enumValues = enumValues;
      } else {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  @Watch("dataProp")
  async organizeFormToShow() {
    if (this.dataProp && this.dataProp.fieldIndex != undefined) {
      this.loadingPropData = true;
      this.editComparationStr = JSON.stringify(this.dataProp.formField);
      await this.editGivenField(this.dataProp);
      this.loadingPropData = false;
    } else {
      this.clearField();
      this.asociateConditionalField();
    }
  }

  async editGivenField(data: EditField) {
    if (data.fieldIndex != undefined) {
      await this.setDinamicSelects({ ...data });
      this.selectIcon =
        data.formField.uiSetup?.iconUrl != undefined
          ? data.formField.uiSetup?.iconUrl
          : "";
      this.selectFieldType = data.formField.type;

      await this.changeFieldType(true, data.formField.type);
      await this.changeElement(true, data.formField.visualElement);
      this.selectDataSchema =
        data.formField.schema.format && data.formField.schema.format == DATE_ID
          ? DATE_ID
          : data.formField.schema.type;
      this.selectVisualElement = data.formField.visualElement;
      data.formField.width && data.formField.width != null
        ? (this.selectWidth = data.formField.width.toString())
        : undefined;

      this.field = _.cloneDeep(data.formField);
      this.field.schema.type =
        data.formField.schema.format == FORM_TEMP_CONSTANTS.FIELD_TYPE.DATE
          ? data.formField.schema.format
          : data.formField.schema.type;
      this.indexEditing = data.fieldIndex;
      this.isEditing = true;
      this.order = this.field.order;
      this.listId = _.clone(this.field.list);
      if (this.field.list) {
        await this.getData(this.listId);
        if (this.field.schema.type === DATA_TYPE_SIMPLE.checkbox) {
          this.listValues = this.field.schema.items?.oneOf as ListSchema[];
        } else {
          this.listValues = this.field.schema.oneOf as ListSchema[];
        }
      }

      if (this.field.formula) {
        let newFormula = this.field.formula.repeat(1);

        this.fields.forEach(item => {
          if (this.field.formula?.includes(item.key)) {
            const regExp = new RegExp(item.key, "g");
            newFormula = newFormula.replace(regExp, `{{${item.schema.title}}}`);
          }
        });

        this.formulaText = newFormula;
      }
      if (data.conditionIndex != undefined) {
        this.conditional = true;
        this.isEditingCondition = true;
        this.selectedCondition = this.formConditions[data.conditionIndex];
        this.conditionIndex = data.conditionIndex;
        this.preCondition = data.conditionIndex;
      }
      this.fieldModalTitle = FORM_TEMP_CONSTANTS.EDIT_FIELD_TITLE;
      // await this.changeFieldType();
      // await this.changeElement(false);
      this.schema.properties.field = this.field.schema;
      if (this.field.schema.items) {
        this.enumValues = this.field.schema.items.enum as string[];
      } else if (this.field.schema.enum) {
        this.enumValues = this.field.schema.enum;
      } else {
        this.enumValues = this.listValues.map(f => f.title);
      }
    }
  }

  cancelOption() {
    this.clearField();
    (this.$refs.form as Vue & {
      resetValidation: () => void;
    }).resetValidation();
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CLOSE_DIALOG);
  }

  onTagSelected(titleField: string) {
    const textarea = (this.$refs.textarea as any).$refs.input;
    const sentence = textarea.value;
    const len = sentence.length;
    let pos = textarea.selectionStart;

    if (pos === undefined) {
      pos = 0;
    }

    const before = sentence.substr(0, pos);
    const after = sentence.substr(pos, len);

    this.formulaText = before + `"${titleField}"` + after;

    this.$nextTick().then(() => {
      textarea.selectionStart = pos + titleField.length;
    });
  }

  formulaValidator() {
    let formulaValue = this.formulaText;

    this.formulaField = formulaValue.repeat(1);
    let fieldExist = false;

    this.fields.forEach(field => {
      if (
        (field.schema.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.NUMBER ||
          (field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST &&
            field.visualElement !== FORM_TEMP_CONSTANTS.FIELD_TYPE.CHECKBOX)) &&
        this.formulaText.includes(`{{${field.schema.title}}}`)
      ) {
        const regexEspecialChars = new RegExp(
          `[${SPECIAL_CHARS_REGEX.map(char => `\\${char}`).join("")}]`,
          "g"
        );
        const fieldTitle = field.schema.title.replace(
          regexEspecialChars,
          "\\$&"
        );
        const regExp = new RegExp(`\\{\\{${fieldTitle}\\}\\}`, "g");
        this.formulaField = this.formulaField.replace(regExp, field.key);
        formulaValue = formulaValue.replace(regExp, "1");
        fieldExist = true;
      }
    });

    if (!fieldExist) {
      return FORMULA_TYPE.ERRORS.FIELD_NOT_FOUND;
    }

    try {
      const result = eval(formulaValue);
      if (
        typeof result === "number" &&
        (result * 0 === 0 || result === Infinity)
      )
        return true;
      return FORMULA_TYPE.ERRORS.SYNTAX;
    } catch (e) {
      return FORMULA_TYPE.ERRORS.SYNTAX;
    }
  }

  changedCondition() {
    this.conditionIndex = this.formConditions.findIndex(
      condition => condition == this.selectedCondition
    );
  }

  inputSchemaMaximun() {
    if (this.field.schema.minimum && this.field.schema.maximum) {
      if (
        Number(this.field.schema.maximum) < Number(this.field.schema.minimum)
      ) {
        this.model = {
          "0": {
            field: Number(this.field.schema.maximum)
          }
        };
      } else {
        this.model = {
          "0": {
            field: Number(this.field.schema.minimum)
          }
        };
      }
    }
  }
  cleanOptions() {
    this.enumValues = [];
    this.field.schema.items = { enum: [], type: "string" };
    this.field.schema.oneOf = [];
    this.field.schema.enum = [];
    this.dynamicSelectList = [];
  }

  addElement() {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.ADD_ELEMENT);
  }

  async setDinamicSelects(data: EditField) {
    const type = this.fieldTypeListConfig.listAll.find(
      item => item.id == data.formField.type
    ) ?? { name: "", id: "" };

    const visualElement = this.visualSelectConfig.listAll.find(
      item => item.id == data.formField.visualElement
    ) ?? { name: "", id: "" };

    const schemaType =
      data.formField.schema.format && data.formField.schema.format == DATE_ID
        ? {
            name: DATA_TYPE.string[2].label,
            id: DATA_TYPE.string[2].value
          } ?? { name: "", id: "" }
        : this.fieldSchemaTypeConfig.listAll.find(
            item => item.id == data.formField.schema.type
          ) ?? { name: "", id: "" };

    this.dataTypeList = [{ label: type.name, value: type.id }];
    this.visualElementModel = [visualElement];
    this.visualElementList = [
      { label: visualElement.name, value: visualElement.id }
    ];
    this.fieldTypeListModel = [type];
    if (data.formField.list) {
      const listSelected = this.dynamicSelectConfig.listAll.find(
        item => item.id == this.listId
      ) ?? { id: "", name: "" };
      this.dynamicSelectList = [listSelected];
      await this.updateSelectList();
    }
    if (data.formField.uiSetup && data.formField.uiSetup.iconUrl) {
      const icon = this.iconSelectConfig.listAll.find(
        item => item.id == data.formField.uiSetup?.iconUrl
      ) ?? { name: "", id: "" };
      this.listIconModel = [{ name: icon.name, value: icon.id }];
    }
    this.dataSchemaTypeModel = [schemaType];
  }
}
